import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface VdaPlacementItem {
    label: string
    id: string
}

class VdaPlacementStore {
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get items(): VdaPlacementItem[] {
        return this._items;
    }

    set items(value: VdaPlacementItem[]) {
        this._items = value;
    }

    private _customerId: string | undefined
    private _items: VdaPlacementItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async init(customerId: string | undefined) {
        if (this._customerId === customerId) {
            return
        }
        this.customerId = customerId
        await this.load()
    }

    async load() {
        const {customerId} = this
        if (!customerId) {
            this.items = []
            return
        }

        const response = await catchApi(async () => api.vda.api.listCustomerPlacementProcesses({
            customerId: customerId
        }))
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.correlationId}`,
                id: `${item.processId}`
            }))
        }
    }

    async loadPlacementProcess(placementProcessId: string | undefined): Promise<VdaPlacementItem | undefined> {
        if (!placementProcessId) {
            return undefined
        }
        const response = await catchApi(async () => api.vda.api.getPlacementProcess(placementProcessId))
        if (response && response.data) {
            return {
                label: `${response.data.correlationId}`,
                id: `${response.data.processId}`
            }
        }
    }
}

const vdaPlacementStore = new VdaPlacementStore()

export {
    vdaPlacementStore
}
